import React, { useState, useEffect } from 'react';

const WeatherForecastButton = () => {
  const [forecastData, setForecastData] = useState(null);
  const [error, setError] = useState(null);
  const [socket, setSocket] = useState(null);  

  useEffect(() => {
    const ws = new WebSocket('ws://localhost:8765');

    ws.onopen = () => {
    //  console.log('WebSocket connection established.');
    };

    ws.onmessage = (event) => {
      const response = JSON.parse(event.data);
      if (response.error) {
        setError(response.error); 
      } else if (response.data) {
        setForecastData(response.data);  
      }
    };

    ws.onclose = () => {
    //  console.log('WebSocket connection closed.');
    };

    ws.onerror = (error) => {
    //  console.error('WebSocket error:', error);
    };

    setSocket(ws);

    return () => {
      if (ws.readyState === WebSocket.OPEN) {
        ws.close();
      }
    };
  }, []);

  const handleButtonClick = () => {
    if (socket) {
      // console.log('WebSocket readyState:', socket.readyState);  
      if (socket.readyState === WebSocket.OPEN) {
        socket.send('run_forecast_script');
      } else {
        //console.error('WebSocket is not open. Cannot send message.');
        setError('WebSocket is not open. Please try again later.');
      }
    } else {
     // console.error('WebSocket is not initialized.');
      setError('WebSocket connection is not initialized.');
    }
  };

  return (
    <div>
      <button onClick={handleButtonClick}>Run Weather Forecast</button>

      {error && (
        <div style={{ color: 'red' }}>
          <strong>Error:</strong> {error}
        </div>
      )}

      {forecastData && (
        <div>
          <strong>Forecast Data:</strong>
          <pre>{forecastData}</pre>
        </div>
      )}
    </div>
  );
};

export default WeatherForecastButton;
